import { ChecklistResource } from '../types/checklistResource';

export interface IResourceAssociation {
  type: ChecklistResource;
  display: string;
}

export const RESOURCE_ASSOCIATIONS: IResourceAssociation[] = [
  {
    type: 'Order',
    display: $localize`Serviceauftrag`,
  },
  {
    type: 'Machine',
    display: $localize`Maschine`,
  },
  {
    type: 'Hygiene',
    display: $localize`Hygiene`,
  },
  {
    type: 'WorkingStep',
    display: $localize`Arbeitsschritt`,
  },
];
